import { render, staticRenderFns } from "./proviewWord.vue?vue&type=template&id=1a50ad44&scoped=true&"
import script from "./proviewWord.vue?vue&type=script&lang=js&"
export * from "./proviewWord.vue?vue&type=script&lang=js&"
import style0 from "./proviewWord.vue?vue&type=style&index=0&id=1a50ad44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50ad44",
  null
  
)

export default component.exports